module.exports = "<p>\r\n    {{t('updateDna.modalBody')|e}}\r\n    <br>\r\n    <a href=\"{{moreInfoUrl|e('html_attr')}}\" target=\"_blank\" class=\"alert-link\">{{t('updateDna.moreInfo', { version: version })|e}} </a>\r\n</p>\r\n";
